import { setSortingRaws } from '../../action/raw';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = {
  field: 'id',
  type: 'ASC'
};

export default createReducer(
  [forAction(setSortingRaws, identityPayload)],
  initialState,
);
